/*
 * RevWorks — Predictive Search.
 *
 * A single shared module (not a per-section {% javascript %} block)
 * because it's genuinely needed by two independent sections — the
 * desktop search overlay (sections/rw-search-overlay.liquid) and the
 * mobile nav's own search panel (sections/header.liquid) — and
 * duplicating this fetch/debounce/stale-response logic in both would
 * be exactly the kind of duplication worth a shared file instead.
 *
 * Fetches sections/predictive-search.liquid via Shopify's documented
 * Section Rendering + Predictive Search APIs
 * (GET {predictive_search_url}?q=...&section_id=predictive-search),
 * so the actual result markup/formatting is real server-rendered
 * Liquid (money formatting, image URLs, title) rather than a second,
 * JS-side reimplementation of that logic.
 */
(function () {
  'use strict';

  function debounce(fn, wait) {
    var timeoutId = null;
    return function () {
      var context = this;
      var args = arguments;
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function bind(options) {
    var input = options.input;
    var resultsContainer = options.resultsContainer;
    var suggestUrl = options.suggestUrl || '/search/suggest';
    var onStateChange = options.onStateChange || function () {};

    if (!input || !resultsContainer) {
      return;
    }

    /* Bumped on every new keystroke-triggered search; a response is
       only applied if its id still matches the latest one sent,
       discarding stale/out-of-order responses (e.g. a slow response
       for "cer" arriving after a faster one for "ceramic"). */
    var requestId = 0;

    function clearResults() {
      resultsContainer.innerHTML = '';
      onStateChange('empty');
    }

    function renderSection(html, thisRequestId) {
      if (thisRequestId !== requestId) {
        return;
      }

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var section = doc.getElementById('shopify-section-predictive-search');
      resultsContainer.innerHTML = section ? section.innerHTML : '';

      var hasResults = !!resultsContainer.querySelector('[data-predictive-search-item]');
      onStateChange(hasResults ? 'results' : 'no-results');
    }

    function search(term) {
      requestId += 1;
      var thisRequestId = requestId;

      if (!term) {
        clearResults();
        return;
      }

      onStateChange('loading');

      var url =
        suggestUrl +
        '?q=' +
        encodeURIComponent(term) +
        '&section_id=predictive-search' +
        '&resources[type]=product' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=hide';

      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(String(response.status));
          }
          return response.text();
        })
        .then(function (html) {
          renderSection(html, thisRequestId);
        })
        .catch(function () {
          if (thisRequestId === requestId) {
            onStateChange('error');
          }
        });
    }

    var debouncedSearch = debounce(function () {
      search(input.value.trim());
    }, 300);

    input.addEventListener('input', debouncedSearch);
  }

  window.RWPredictiveSearch = { bind: bind };
})();
